import React from 'react';

import { OutlineButton } from '../../Button/OutlineButton/OutlineButton';
import type { ButtonTextColorMode, CommonButtonProps } from '../../Button/types';
import * as styles from './styles';

export interface RoundButtonProps extends CommonButtonProps {
  size: 'small' | 'large';
  textColorMode?: ButtonTextColorMode;
}

/** @deprecated use `IconButton` instead */
export const RoundButton = ({ children, id = '', onClick, size, ...props }: RoundButtonProps) => (
  <OutlineButton
    css={[styles.buttonOverrides, size === 'small' ? styles.small : styles.large]}
    id={id}
    onClick={onClick}
    {...props}
  >
    {children}
  </OutlineButton>
);
